import React from "react";
import { Button } from "react-bootstrap";

export function RestlessButtonFormatter(
  cellContent,
  row,
  rowIndex,
  { buttonsArr } //buttonsArr = {onClickFunction, icon, text}
) {
 
  return (
    <div className="row">
      {buttonsArr?.map((btn) => {
        return (
          <div className="d-flex justify-content-center mx-1">
            <Button
              title={btn.title?btn.title:""}
              className="btn btn-icon btn-primary"
              disabled={
                (btn.disabled && row.deleted) || 
                (btn.disabled && row.content?.deleted) ||
                (btn.disabled && row.status === "KICKEDOUT") ||
                (btn.disabled && btn.postactions && row.restless_user.status !== "ADMIN")
              }
              onClick={() => btn.onClickFunction(row)}
            >
              
              <span className="svg-icon svg-icon-md">{btn.icon}</span>
            </Button>
          </div>
        );
      })}
    </div>
  );
}
